export default [
  {
    value: 'live',
    title: 'Live',
  }, {
    value: 'preview',
    title: 'Preview',
  },
];
